var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSponsors)?_c('TournamentSponsors',{staticClass:"tournament-card_sponsors",attrs:{"sponsors":_vm.sponsors,"height":_vm.height,"align":_vm.align}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }